import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
    Grid,
    Typography,
    Alert
} from '@mui/material';
import {
    CustomTextField,
    TabTextLabel,
    SingleButton,
} from '@/shared/components/ui';
import { testRouterFormSchema } from "@/shared/utils";
import {
    GetRoutersParams,
    useTestRouter,
} from "@/store/erp/router";
import { gridSizeMdLg12, gridSizeMdLg6 } from "@/shared";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { RouterTestResult } from '@/shared/interfaces/erp/routers/router-test.interface';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';

type TestFormData = GetRoutersParams & {};

export default function PruebaConectividad() {

    ///* form
    const form = useForm<TestFormData>({
        resolver: yupResolver(testRouterFormSchema as any),
        defaultValues: {
            username: 'orlando',
            password: 'integra12',
            puerto_api: '8728',
        },
    });

    const {
        handleSubmit,
        formState: { errors },
    } = form;

    const [resultadoRouter, setResultadoRouter] = useState<RouterTestResult[]>([]);
    const { mutateAsync: testRouterMutation } = useTestRouter();
    const onSave = async (data: TestFormData) => {
        ///* obtener
        try {
            const res = await testRouterMutation(data);
            console.log({res});
            setResultadoRouter(res?.data || []);
        } catch (error) {
            console.error("Falló la conexión:", error);
        }
    };

    return (
        <Grid {...gridSizeMdLg12} container item spacing={3}>
            <Grid container item {...gridSizeMdLg12}>
                <Alert severity="info" sx={{ bgcolor: "info.light" }}>
                    <Typography variant="body2">
                        <strong>Información:</strong> Considerar primero la configuración del router Mikrotik los permisos API.
                    </Typography>
                </Alert>
            </Grid>

            <Grid container item {...gridSizeMdLg6}>
                <Grid container item gap={2} spacing={2} {...gridSizeMdLg12}>
                    <TabTextLabel text="Datos de Conexión" pb="33px" />
                    <CustomTextField
                        label="Dirección IP / Hostname"
                        name="ip"
                        control={form.control}
                        defaultValue={form.getValues().ip}
                        error={errors.ip}
                        helperText={errors.ip?.message}
                    />
                    <CustomTextField
                        type="lower"
                        label="Username API"
                        name="username"
                        control={form.control}
                        defaultValue={form.getValues().username}
                        error={errors.username}
                        helperText={errors.username?.message}
                    />
                    <CustomTextField
                        label="Password API"
                        name="password"
                        control={form.control}
                        defaultValue={form.getValues().password}
                        error={errors.password}
                        helperText={errors.password?.message}
                    />
                    <CustomTextField
                        label="Puerto API"
                        name="puerto_api"
                        control={form.control}
                        defaultValue={form.getValues().puerto_api}
                        error={errors.puerto_api}
                        helperText={errors.puerto_api?.message}
                    />
                    <SingleButton
                        color={'success'}
                        variant="outlined"
                        label="Comprobar Conexión"
                        startIcon={<TaskAltIcon />}
                        onClick={handleSubmit(
                            onSave,
                            (formErrors) => {
                                Object.entries(formErrors).forEach(([key, error]) => {
                                    console.log(`Problema con ${key}: ${error?.message}`);
                                });
                            }
                        )}
                    />
                </Grid>
            </Grid>
            <Grid container item {...gridSizeMdLg6}>
                <Grid {...gridSizeMdLg12} container item gap={2} spacing={2}>
                    <TabTextLabel text="Resultado de Conexión" pb="33px" />
                    <Grid {...gridSizeMdLg12} container item gap={2} spacing={2}>
                        {resultadoRouter?.map((item) => (
                            <CustomAlertCard
                                alertColor={item?.status === "success" ? "success" : "error"}
                                alertTitle={
                                    item?.status === "success" ? `✓ ${item?.router} ${item?.identity} Router Operativo` : `✗ ${item?.router} Router No Operativo`
                                }
                                alertMessage={
                                    item?.status === "success" ? "El router se encuentra operativo. Conexión exitosa." 
                                    : 
                                    (`El router no está operativo. Por favor, verifique los valores ingresados en los detalles del router correspondiente. Detalle de respuesta: ${item?.mensaje}`)?.slice(0, 800)
                                }
                                bgColorAlert={
                                    item?.status === "success" ? "GREEN" : "RED"
                                }
                            />
                            
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
